export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    fixed: "left",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "批次包",
    dataIndex: "pkgCode",
    key: "pkgCode",
    fixed: "left",
    width: 150,
    scopedSlots: {
      customRender: "pkgCode",
    },
  },
  {
    title: "单/多件",
    dataIndex: "singleProductFlag",
    key: "singleProductFlag",
    width: 130,
    scopedSlots: {
      customRender: "singleProductFlag",
    },
  },
  {
    title: "商品图片",
    dataIndex: "img",
    key: "img",
    width: 120,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "采购单类型",
    dataIndex: "purchaseType",
    key: "purchaseType",
    width: 180,
    customRender: (text, record, index) => {
      return [
        record.bizType == 1
          ? "档口采购单"
          : record.bizType == 2
          ? "线上采购单"
          : "普通采购单",
        "OEM大货单",
        "OEM样品单",
      ][text];
    },
  },
  {
    title: "订单来源",
    dataIndex: "systemSource",
    key: "systemSource",
    width: 130,
    customRender: (text, record, index) => {
      return { 1: "D2C", 2: "B2B" }[text];
    },
  },
  {
    title: "是否组合商品",
    dataIndex: "combinationProductItemFlag",
    key: "combinationProductItemFlag",
    width: 180,
    customRender: (text, record, index) => {
      return text == 1 ? "组合商品" : "非组合商品";
    },
  },
  {
    title: "移库区域",
    dataIndex: "sourceName",
    key: "sourceName",
  },
  {
    title: "移库至",
    dataIndex: "targetName",
    key: "targetName",
    // scopedSlots: {
    //     customRender: 'targetNameAction'
    // }
  },
  {
    title: "件数",
    dataIndex: "amount",
    key: "amount",
    width: 130,
    // width: 200,
    // ellipsis: true,
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
    scopedSlots: {
      customRender: "productName",
    },
  },
  {
    title: "特殊质检要求",
    dataIndex: "specialCheckRequirement",
    key: "specialCheckRequirement",
    scopedSlots: {
      customRender: "specialCheckRequirement",
    },
  },
];
export const testDataSource = [
  {
    id: 0,
    pkgCode: "GHS03082085334",
    area: 0,
    transferAmount: 0,
    transferType: 0,
    productName: "狐狸",
    productImg:
      "https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg",
    productSku: "SKU3429773792",
  },
  {
    id: 10,
    pkgCode: "KHS03082085334",
    transferAmount: 0,
    area: 3,
    transferType: 0,
    productName: "狐狸",
    productImg:
      "https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg",
    productSku: "SKU342977234234",
  },
];
